import { getTimezones } from './get-timezones';

export const TimezonesAPI = {
  getTimezones,
};
